import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import merge from 'deepmerge';
import { Suspense, startTransition, useEffect, useMemo } from 'react';
import { createTheme } from '../../system';
import { ThemeStoreProvider, useThemeStore } from './theme.store';
import { darkTheme } from '../../themes/dark.theme';
import { themes as defaultThemes } from '../../themes';
import { lightTheme } from '../../themes/light.theme';
export const UIProvider = ({ isDarkMode = false, theme = {
    light: lightTheme,
    dark: darkTheme
}, children }) => {
    const themeInstance = useMemo(() => {
        if (!theme) {
            return;
        }
        const light = createTheme('light', theme.light);
        const dark = createTheme('dark', merge(defaultThemes.dark, theme.dark));
        // Hack to force the theme to be loaded
        light.className;
        dark.className;
        return {
            light,
            dark
        };
    }, [theme]);
    return (_jsxs(ThemeStoreProvider, { initialState: {
            isDarkMode,
            theme: themeInstance
        }, children: [_jsx(Suspense, { children: _jsx(ThemeWatcher, {}) }), children] }));
};
UIProvider.displayName = 'UIProvider';
const ThemeWatcher = () => {
    const isDarkMode = useThemeStore(s => s.isDarkMode);
    useEffect(() => {
        startTransition(() => {
            const newClass = isDarkMode ? 'dark' : 'light';
            if (document.documentElement.classList.contains(newClass)) {
                return;
            }
            for (const t of ['light', 'dark']) {
                document.documentElement.classList.remove(t);
            }
            document.documentElement.classList.add(newClass);
        });
    }, [isDarkMode]);
    return null;
};
export * from './theme.store';
